"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);










/* Each patient chat's translation state, as the server last sent it. A
 * missing entry means "not known": no translated text, pill or controls. */





































const chatSyncId = (conversationKey) => `chat:${conversationKey}`
const orgSyncId = (orgKey) => `org:${orgKey}`

/* Every chat translation command answers with the chat's new state
 * (TranslateFromMessage nests it under Translation; see chatStateOf). */
const conversationStateSuccessTypes = new Set([
  _actionCreators2.default.getConversationTranslationActions.SUCCESS.type,
  _actionCreators2.default.setPatientTranslationActions.SUCCESS.type,
  _actionCreators2.default.stopTranslatingActions.SUCCESS.type,
  _actionCreators2.default.markMessageEnglishActions.SUCCESS.type,
  _actionCreators2.default.translateFromMessageActions.SUCCESS.type,
])

/* The chat state a chat command's SUCCESS carries. */
const chatStateOf = (action) => {
  if (action.type === _actionCreators2.default.translateFromMessageActions.SUCCESS.type) {
    // SAFETY: TranslateFromMessage answers { Outcome, Translation }.
    return _optionalChain([(action.payload ), 'optionalAccess', _ => _.Translation])
  }
  // SAFETY: every other chat command answers with the ConversationTranslation.
  return action.payload 
}

const orgSettingsSuccessTypes = new Set([
  _actionCreators2.default.getOrgTranslationSettingsActions.SUCCESS.type,
  _actionCreators2.default.updateOrgTranslationSettingsActions.SUCCESS.type,
])

const EMPTY_CONVERSATIONS = {}
const EMPTY_ORG_SETTINGS = {}
const INITIAL_SYNC = {
  active: {}, translating: {}, applied: {}, chatFloor: 0, pillDismissed: {},
}

const seqOf = (action) => {
  const seq = _optionalChain([action, 'access', _2 => _2.meta, 'optionalAccess', _3 => _3.seq])
  return typeof seq === 'number' ? seq : undefined
}

/* Whether an answer stamped `seq` is newer than what is applied for `id`.
 * An unstamped answer always applies. */
const isFresh = (
  sync,
  id,
  seq,
  floor = 0,
) => seq === undefined || seq > Math.max(_nullishCoalesce(_optionalChain([sync, 'optionalAccess', _4 => _4.applied, 'access', _5 => _5[id]]), () => ( 0)), floor)

/* The chat or org an answer belongs to, for the sync bookkeeping. */
const answerSyncId = (action) => {
  if (conversationStateSuccessTypes.has(action.type)) {
    const key = _optionalChain([chatStateOf, 'call', _6 => _6(action), 'optionalAccess', _7 => _7.ConversationKey])
    return key ? chatSyncId(key) : undefined
  }
  if (orgSettingsSuccessTypes.has(action.type)) {
    // SAFETY: an org settings command's SUCCESS payload is OrgTranslationSettings.
    const key = _optionalChain([(action.payload ), 'optionalAccess', _8 => _8.OrgKey])
    return key ? orgSyncId(key) : undefined
  }
  return undefined
}

const without = (record, keys) => {
  if (!keys.some(key => key in record)) return record
  const next = { ...record }
  for (const key of keys) delete next[key]
  return next
}

 function conversationTranslationsReducer (
  state = EMPTY_CONVERSATIONS,
  action,
  root,
) {
  if (conversationStateSuccessTypes.has(action.type)) {
    const next = chatStateOf(action)
    if (!_optionalChain([next, 'optionalAccess', _9 => _9.ConversationKey])) return state
    const sync = _optionalChain([root, 'optionalAccess', _10 => _10.translationSync])
    if (!isFresh(sync, chatSyncId(next.ConversationKey), seqOf(action), _optionalChain([sync, 'optionalAccess', _11 => _11.chatFloor]))) return state
    return { ...state, [next.ConversationKey]: next }
  }
  if (action.type === _actionCreators2.default.translationStatesInvalidatedAction.type) {
    // SAFETY: the type is translationStatesInvalidatedAction's.
    const keys = (action.payload ).ConversationKeys
    if (!keys) return Object.keys(state).length ? EMPTY_CONVERSATIONS : state
    return without(state, keys)
  }
  // Chat states carry the org's switch but not the org, so a settings change
  // drops them all; the open chats refetch. Until they do (or if that
  // fails) nothing translated shows.
  if (action.type === _actionCreators2.default.updateOrgTranslationSettingsActions.SUCCESS.type ||
    action.type === _actionCreators2.default.logoutAction.type) {
    return Object.keys(state).length ? EMPTY_CONVERSATIONS : state
  }
  return state
} exports.conversationTranslationsReducer = conversationTranslationsReducer;

 function orgTranslationSettingsReducer (
  state = EMPTY_ORG_SETTINGS,
  action,
  root,
) {
  if (orgSettingsSuccessTypes.has(action.type)) {
    // SAFETY: both org settings commands answer with OrgTranslationSettings.
    const next = action.payload 
    if (!_optionalChain([next, 'optionalAccess', _12 => _12.OrgKey])) return state
    if (!isFresh(_optionalChain([root, 'optionalAccess', _13 => _13.translationSync]), orgSyncId(next.OrgKey), seqOf(action))) return state
    return { ...state, [next.OrgKey]: next }
  }
  if (action.type === _actionCreators2.default.logoutAction.type) {
    return Object.keys(state).length ? EMPTY_ORG_SETTINGS : state
  }
  return state
} exports.orgTranslationSettingsReducer = orgTranslationSettingsReducer;

/* ConversationKeys: the chats to drop; omitted, every chat. */

















 function translationSyncReducer (
  state = INITIAL_SYNC,
  action,
) {
  if (action.type === _actionCreators2.default.translationChatOpenedAction.type) {
    // SAFETY: both chat opened/closed actions carry the ConversationKey.
    const key = action.payload 
    return { ...state, active: { ...state.active, [key]: (_nullishCoalesce(state.active[key], () => ( 0))) + 1 } }
  }
  if (action.type === _actionCreators2.default.translationChatClosedAction.type) {
    // SAFETY: as above.
    const key = action.payload 
    const count = (_nullishCoalesce(state.active[key], () => ( 0))) - 1
    if (count > 0) return { ...state, active: { ...state.active, [key]: count } }
    return { ...state, active: without(state.active, [key]) }
  }
  if (action.type === _actionCreators2.default.translateFromMessageStartedAction.type) {
    // SAFETY: both Translate started/finished actions carry the ConversationKey.
    const key = action.payload 
    return { ...state, translating: { ...state.translating, [key]: true } }
  }
  if (action.type === _actionCreators2.default.translateFromMessageFinishedAction.type) {
    // SAFETY: as above.
    const key = action.payload 
    return { ...state, translating: without(state.translating, [key]) }
  }
  if (action.type === _actionCreators2.default.translationPillDismissedAction.type) {
    // SAFETY: the type is translationPillDismissedAction's.
    const key = (action.payload ).ConversationKey
    if (_optionalChain([state, 'access', _14 => _14.pillDismissed, 'optionalAccess', _15 => _15[key]])) return state
    return { ...state, pillDismissed: { ...state.pillDismissed, [key]: true } }
  }
  if (action.type === _actionCreators2.default.languageOfferedAction.type) {
    // SAFETY: the type is languageOfferedAction's.
    return { ...state, languageOffer: action.payload  }
  }
  if (action.type === _actionCreators2.default.languageOfferClosedAction.type) {
    return state.languageOffer ? { ...state, languageOffer: undefined } : state
  }
  if (action.type === _actionCreators2.default.logoutAction.type) {
    return Object.keys(_nullishCoalesce(state.pillDismissed, () => ( {}))).length || state.languageOffer
      ? { ...state, pillDismissed: {}, languageOffer: undefined }
      : state
  }

  const seq = seqOf(action)
  if (seq === undefined) return state

  if (action.type === _actionCreators2.default.translationStatesInvalidatedAction.type) {
    // SAFETY: the type is translationStatesInvalidatedAction's.
    const keys = (action.payload ).ConversationKeys
    if (!keys) return { ...state, chatFloor: Math.max(state.chatFloor, seq) }
    const applied = { ...state.applied }
    for (const key of keys) applied[chatSyncId(key)] = Math.max(_nullishCoalesce(applied[chatSyncId(key)], () => ( 0)), seq)
    return { ...state, applied }
  }

  const id = answerSyncId(action)
  if (!id) return state
  const floor = id.startsWith('chat:') ? state.chatFloor : 0
  if (!isFresh(state, id, seq, floor)) return state
  const next = { ...state, applied: { ...state.applied, [id]: seq } }
  if (action.type === _actionCreators2.default.updateOrgTranslationSettingsActions.SUCCESS.type) {
    next.chatFloor = Math.max(state.chatFloor, seq)
  }
  return next
} exports.translationSyncReducer = translationSyncReducer;
